import { render, staticRenderFns } from "./IpRadioGeneralAdminUserSetting.vue?vue&type=template&id=b74aa540&scoped=true"
import script from "./IpRadioGeneralAdminUserSetting.vue?vue&type=script&lang=js"
export * from "./IpRadioGeneralAdminUserSetting.vue?vue&type=script&lang=js"
import style0 from "./IpRadioGeneralAdminUserSetting.vue?vue&type=style&index=0&id=b74aa540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74aa540",
  null
  
)

export default component.exports